import { Skeleton, styled } from '@mui/material';

export const StyledSkeleton = styled(Skeleton)`
  border-radius: 5px;
`;
